export function s3ThemeAssetUrl(assetPath) {
  const raw = String(assetPath || "").trim();
  if (!raw) return "";

  if (/^https?:\/\//i.test(raw)) return raw;

  const base = (process.env.REACT_APP_S3_PATH || "").trim().replace(/\/+$/, "");
  const cleaned = raw.replace(/^\/+/, "");
  return base ? `${base}/${cleaned}` : cleaned;
}

